<template>
    <div class="tw-main">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'tw-main'
}
</script>

<style>

</style>